module.exports = __webpack_public_path__ + "static/img/snip3down.71ec3be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/coach/snip3down.png
// module id = 9cwo
// module chunks = 35